const performanceTab =  {
    LOAD_PERFORMANCE_TAB: "LOAD_PERFORMANCE_TAB",
    LOADED_PERFORMANCE_TAB: "LOADED_PERFORMANCE_TAB",
    ERROR_LOADING_PERFORMANCE_TAB: "ERROR_LOADING_PERFORMANCE_TAB",
    CHANGE_PERFORMANCE_SETTINGS_VALUE: "CHANGE_PERFORMANCE_SETTINGS_VALUE",
    SAVE_PERFORMANCE_SETTINGS: "SAVE_PERFORMANCE_SETTINGS",
    SAVED_PERFORMANCE_SETTINGS: "SAVED_PERFORMANCE_SETTINGS",
    ERROR_SAVING_PERFORMANCE_SETTINGS: "ERROR_SAVING_PERFORMANCE_SETTINGS",
    INCREMENT_VERSION: "INCREMENT_VERSION",
    INCREMENTED_VERSION: "INCREMENTED_VERSION",
    ERROR_INCREMENTING_VERSION: "ERROR_INCREMENTING_VERSION"
};

export default performanceTab;